import { render, staticRenderFns } from "./stockbatch_list.vue?vue&type=template&id=784dbadf&scoped=true"
import script from "./stockbatch_list.vue?vue&type=script&lang=js"
export * from "./stockbatch_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784dbadf",
  null
  
)

export default component.exports